var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThemeSystem = function SvgThemeSystem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9,
    viewBox: "0 0 24 24",
    className: "svgr-icon"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 13,
    x: 2.5,
    y: 4,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 21h7M12 17v4"
  })));
};
export default SvgThemeSystem;